import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const COOKIE_KEY = 'lucods_cookie_consent';

declare global {
  interface Window {
    // Add the property to the Window type to fix TS7015
    'ga-disable-G-V200NTL7CP'?: boolean;
    fbq?: (...args: any[]) => void;
    LucodsOpenCookieConsent?: () => void;
    dataLayer?: any[];
  }
}

type ConsentType = 'accepted' | 'rejected' | 'custom' | null;

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [customizing, setCustomizing] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  const [marketing, setMarketing] = useState(true);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY) as ConsentType;
    if (!consent) setVisible(true);
    // Expose a function to open the banner again
    window.LucodsOpenCookieConsent = () => setVisible(true);
  }, []);

  const handleConsent = (type: ConsentType) => {
    if (type === 'accepted') {
      localStorage.setItem(COOKIE_KEY, 'accepted');
      enableAnalytics();
      enableMarketing();
    } else if (type === 'rejected') {
      localStorage.setItem(COOKIE_KEY, 'rejected');
      disableAnalytics();
      disableMarketing();
    } else if (type === 'custom') {
      localStorage.setItem(COOKIE_KEY, JSON.stringify({ analytics, marketing }));
      if (analytics) enableAnalytics(); else disableAnalytics();
      if (marketing) enableMarketing(); else disableMarketing();
    }
    setVisible(false);
    setCustomizing(false);
  };

  const enableAnalytics = () => {
    window['ga-disable-G-V200NTL7CP'] = false;
    // Optionally, initialize GA if not already loaded
    if (!window.dataLayer) {
      // @ts-ignore
      import('../../../utils/google-analytics').then(mod => mod.initGoogleAnalytics && mod.initGoogleAnalytics());
    }
  };

  const disableAnalytics = () => {
    window['ga-disable-G-V200NTL7CP'] = true;
  };

  const enableMarketing = () => {
    // Optionally, initialize FB Pixel if not already loaded
    if (!window.fbq) {
      // @ts-ignore
      import('../../../utils/facebook-pixel').then(mod => mod.initFacebookPixel && mod.initFacebookPixel());
    }
  };

  const disableMarketing = () => {
    // No standard way to disable FB Pixel after load, but don't load if not consented
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-banner">
      <span>
        Usamos cookies para mejorar tu experiencia y analizar el tráfico. Consulta nuestra{' '}
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Política de Privacidad</a>.
      </span>
      <div className="cookie-consent-actions">
        <button className="cookie-btn accept" onClick={() => handleConsent('accepted')}>Aceptar todo</button>
        <button className="cookie-btn reject" onClick={() => handleConsent('rejected')}>Rechazar todo</button>
        <button className="cookie-btn" onClick={() => setCustomizing(v => !v)}>Configurar</button>
      </div>
      {customizing && (
        <div className="cookie-customize-panel">
          <label>
            <input type="checkbox" checked={analytics} onChange={e => setAnalytics(e.target.checked)} />
            Cookies de análisis (Google Analytics)
          </label>
          <label>
            <input type="checkbox" checked={marketing} onChange={e => setMarketing(e.target.checked)} />
            Cookies de marketing (Facebook Pixel)
          </label>
          <button className="cookie-btn accept" onClick={() => handleConsent('custom')}>Guardar preferencias</button>
        </div>
      )}
    </div>
  );
};

export default CookieConsent;
